import { render, staticRenderFns } from "./lockSettings.vue?vue&type=template&id=32785534&scoped=true&"
import script from "./lockSettings.vue?vue&type=script&lang=js&"
export * from "./lockSettings.vue?vue&type=script&lang=js&"
import style0 from "./lockSettings.vue?vue&type=style&index=0&id=32785534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32785534",
  null
  
)

export default component.exports